import { render, staticRenderFns } from "./RiskEntry.vue?vue&type=template&id=759c30e2&scoped=true"
import script from "./RiskEntry.vue?vue&type=script&lang=ts"
export * from "./RiskEntry.vue?vue&type=script&lang=ts"
import style0 from "./RiskEntry.vue?vue&type=style&index=0&id=759c30e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759c30e2",
  null
  
)

export default component.exports